const inputsValidations = {
  emailRequired: 'البريد الإلكتروني مطلوب',
  nameRequired: 'الاسم مطلوب',
  locationNameRequired: 'الاسم المكان باللغة الانجليزية مطلوب',
  locationNameArRequired: 'الاسم المكان باللغة العربية مطلوب',
  enNameRequired: 'الاسم باللغة الانجليزية مطلوب',
  arNameRequired: 'الاسم باللغة العربية مطلوب',
  arabicLettersRequired: 'الحروف العربية مطلوبة',
  pickOneCategoryAtLeast: 'يجب اختيار فئة واحدة علي الأقل',
  pickOneWorkingDayAtLeast: 'يجب اختيار يوم عمل واحد علي الأقل',
  pickOneCoverageZoneAtLeast: 'يجب اختيار منطقة واحدة علي الأقل',
  genderRequired: 'اختيار نوع الفئة المسهدفة مطلوب',
  paymentMenthodRequired: 'اختيار طرق الدفع مطلوبة',
  specialtyRequired: 'اختيار التخصص مطلوب',
  logoRequired: 'اختيار الشعار مطلوب',
  bannerRequired: 'اختيار صورة الغلاف مطلوب',
  categoryRequired: 'اختيار الفئة مطلوبة',
  roleRequired: 'الوظيفة مطلوبة',
  passwordRequired: 'كلمة المرور مطلوبة',
  tempPasswordRequired: 'كلمة المرور المؤقتة مطلوبة ',
  oldPasswordRequired: 'كلمة المرور الحالية مطلوبة ',
  streetNumberRequired: 'رقم الشارع مطلوب ',
  streetNameRequired: 'اسم الشارع مطلوب ',
  buildingNumberRequired: 'رقم المبني مطلوب ',
  newPasswordRequired: 'كلمة مرور الجديدة مطلوبة',
  postalCodeNumberOnly: 'الرمز البريدي يقبل 5 ارقام فقط',
  validEmailFormat: 'يجب أن يكون البريد الإلكتروني عنوان بريد إلكتروني صالحًا',
  uniqeEmailRequired: 'يتم استخدام هذا البريد الإلكتروني من قبل، ويجب أن يكون البريد الإلكتروني موحدًا',
  confirmNewPasswordRequired: 'تأكيد كلمة المرور الجديدة مطلوب',
  passwordIsNotMatched: 'كلمات المرور يجب أن تتطابق',
  passwordNotFollowREGEX:
    'يجب أن تحتوي كلمات المرور على 8 أحرف على الأقل ؛ مزيج من الأحرف (الكبيرة والصغيرة) والأرقام والرموز',
  nameNotFollowREGEX: 'الاسم لا يجب أن يحتوى علي رموز',
  englishLettersOnly: 'هذا الحقل يقبل اللغة الانجليزية فقط',
  arabicLettersOnly: 'هذا الحقل يقبل اللغة العربية فقط',
  englishLettersAndSpecialCharactersOnly: 'هذا الحقل يقبل اللغة الانجليزية و الرموز فقط',
  arabicLettersAndSpecialCharactersOnly: 'هذا الحقل يقبل اللغة العربية و الرموز فقط',
  atleastTwoEnglishCharacters: 'هذا الحقل يجب أن يحتوي على 2 حروف انجليزية على الأقل',
  atleastTwoArabicCharacters: 'هذا الحقل يجب أن يحتوي على 2 حروف عربية على الأقل',
  englishSpaceDashSingleQuote: 'هذا الحقل يقبل اللغة الانجليزية و الفراغ و الفاصلة و الاقتباسات',
  arabicDiacriticsSpaceDashSingleQuote: 'هذا الحقل يقبل اللغة العربية و الفراغ و الفاصلة و الاقتباسات',
  englishSpaceDashSingleQuoteAndNumbers: 'هذا الحقل يقبل اللغة الانجليزية و الفراغ و الفاصلة و الاقتباسات و الارقام',
  arabicDiacriticsSpaceDashSingleQuoteAndNumbers: 'هذا الحقل يقبل اللغة العربية و الفراغ و الفاصلة و الاقتباسات و الارقام',
  numbersOnly: 'هذا الحقل يقبل الارقام فقط',
  positiveTwoDecimalOnly: 'هذا الحقل يقبل رقم موجب و 2 منزلة عشرية فقط',
  zeroOrPositiveTwoDecimalOnly: 'هذا الحقل يسمح بالأرقام من صفر فما فوق، بما في ذلك الارقام العشرية',
  positiveNegativeTwoDecimalOnly: 'هذا الحقل يقبل رقم 2 منزلة عشرية فقط',
  positiveNumber: 'هذا الحقل يقبل الارقام الموجبة فقط',
  invalidDate: 'التاريخ غير صالح',
  shouldNotBeBeforeToday: 'التاريخ لا يجب أن يكون قبل اليوم',
  uploadTypeError: 'الصيغات المقبولة هي jpg و jpeg و png و bmp فقط',
  uploadSizeError: 'اقصي حجم 2MB',
  regionRequired: 'المنطقة مطلوبة',
  cityRequired: 'المدينة مطلوبة',
  countryRequired: 'الدولة مطلوبة',
  required: 'هذا الحقل مطلوب',
  zeroAndPositiveNumber: 'هذا الحقل يقبل أرقام صحيحة تبدأ من 0',
  numbersStartingFrom2: 'هذا الحقل يقبل أرقام تبدأ من 2',
  positiveInteger: ' هذا الحقل يقبل أرقام صحيحة موجبة فقط',
  startingFromZero: ' هذا الحقل قبل أرقام تبدأ من الصفر فقط',
  integerNumber: 'هذا الحقل يقبل أرقام صحيحة فقط',
  maximumChars100: 'الحد الأقصى للحروف 100',
  maximumChars50: 'الحد الأقصى للحروف 50',
  atLeastWorkinghour: "مطلوب على الأقل يوم عمل واحد",
  ToTimeShouldBeAfterFromTime: "يجب ان يكون وقت الانتهاء بعد وقت الابتداء",
  fromTimeShouldBeBeforeToTime: "يجب ان يكون وقت الابتداء قبل وقت الانتهاء",
  allowLocationAccessMsg:"يرجى السماح بإذن تتبع الموقع من اعدادات المتصفح لتحديد المنطقة المدعومة",
  acceptedSize:"الحجم الأقصى 5MB",
  acceptedFilesImgPdf:"الصيغات المقبولة: pfd, png, jpg, jpeg",
  // onlyArabicSpaceDotCommaSemicolon:"الحقل يقبل فقط حروف عربية و[ , / ; / . ]",
  // onlyEnglishSpaceDotCommaSemicolon:"الحقل يقبل فقط حروف انجليزية و[ , / ; / . ]",
  onlyArabicSpaceDotCommaSemicolon:"الحقل يقبل فقط الحروف الانجليزية و الحروف الخاصة",
  onlyEnglishSpaceDotCommaSemicolon:" الحقل يقبل فقط الحروف انجليزية و الحروف الخاصة",
  englishAndSpecialCharacters:"الحقل يقبل فقط الحروف الانجليزية و الحروف الخاصة",
  arabicAndSpecialCharacters:"الحقل يقبل فقط الحروف العربية و الحروف الخاصة",
  atleastTwoEnglishCharacters:"يجب على هذا الحقل ان يحتوي على 2 حروف انجليزية على الأقل",
  atleastTwoArabicCharacters:"يجب على هذا الحقل ان يحتوي على 2 حروف عربية على الأقل",
  minimumTwoSessionsRequired: "الحد الأدنى المطلوب جلستان",
};

export default inputsValidations;
